  <mat-card class="cardBac animated slideInRight delay-1_5s">
    <mat-card-header>
      <mat-card-title>
        {{datoActivity.labelTitle[idiomaActual]}}
      </mat-card-title>
      <mat-card-subtitle>
        {{datoActivity.labelSubTitle[idiomaActual]}}
      </mat-card-subtitle>
    </mat-card-header>
    <mat-card-content  fxFlex="100" >
      <div class="card__main actividad" fxLayout="column" fxLayoutAlign="space-between stretch">
        <div class="card__row" *ngFor="let history of historyEventCompany">
          <div class="card__icon"><mat-icon >{{history.icon}}</mat-icon></div>
          <div class="card__detail">
            <div class="card__source text-bold">{{'NOTIFICACION_PRODUCT.PRODUCTOS_ID.' + history.product | translate}} {{history.dateProduct}}</div>
            <div class="card__description"><span>{{'NOTIFICACION_PRODUCT.TIPO_MENSAJE_MOSTRAR.' + history.desription | translate}}</span></div>
            <div class="card__note">{{history.date | date:'short'}}</div>
          </div>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
